import styled, { css } from 'styled-components';
import { getBackgroundColor, darken, themeGet } from '@magalu/stereo-ui-styles';

const getBulletStyle = ({
  quantity = 0,
  size = 6,
  color = 'rgba(0, 0, 0, 0.3)'
}) => css`
  width: ${size}px;
  height: ${size}px;
  background-color: ${color};
  border-radius: 50%;
  margin-right: calc((100% / ${quantity}) - ${size}px);

  &:last-child {
    margin-right: ${size}px;
  }
`;

export const Bullets = styled.div`
  position: relative;
  height: ${({
  height
}) => height};

  display: flex;
  justify-content: flex-end;
  align-items: center;

  div {
    ${({
  bullets
}) => getBulletStyle(bullets)}
  }
`;
export const Container = styled.div`
  position: relative;
  width: ${({
  width
}) => width || `100%`};
  height: ${({
  height
}) => height || `auto`};
`;
export const Progress = styled.progress`
  position: absolute;
  width: ${({
  width
}) => width || `100%`};
  height: ${({
  height
}) => height || `auto`};
  border-radius: ${themeGet('radii.big')};
  appearance: none;
  border: none;

  &::-webkit-progress-bar {
    height: ${({
  height
}) => height};
    border-radius: ${themeGet('radii.big')};
    background-color: ${props => getBackgroundColor('whisper')(props)};
  }

  &::-webkit-progress-value {
    height: ${({
  height
}) => height};
    border-radius: ${themeGet('radii.big')};
    background-color: ${({
  color
}) => color};
  }

  &::-moz-progress-bar {
    height: ${({
  height
}) => height};
    border-radius: ${themeGet('radii.big')};
    background-color: ${({
  color
}) => color};
  }
`;
export const Label = styled.span`
  font-size: ${props => themeGet('fontSizes.3')(props)}px;
  color: ${({
  color
}) => darken(color, 15)};
  font-weight: ${props => themeGet('fontWeights.bold')(props)};

  position: absolute;
  left: ${({
  value
}) => value && `calc(${value}% - 22px)`};
  top: -25px;
`;